import { FormattedMessage } from "react-intl";

const EnterpriseSupport = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.enterpriseSupport.content.body"
                    defaultMessage="30-min response time for critical issues with dedicated phone number and senior support team."
                />
            </p>
        </div>
    );
};

export default EnterpriseSupport;
